export const fixedHeader = () => {
    const header = document.querySelector('.site-header');
    const operationType = header && Math.floor(window.scrollY) > 0 ? 'add' : 'remove';
    header.classList[operationType]('sticky');
}

export const mobileMenu = () => {
    const button = document.querySelector('.js-mobile-menu-toggle');
    const mobile_menu = document.querySelector('.js-mobile-menu');
    button && button.addEventListener( 'click', (e) => {
      if (e.target.classList.contains('active')) {
        e.target.classList.remove('active');
        document.body.classList.remove('menu-opened');
        mobile_menu.classList.remove('menu-opened');
      } else {
        document.body.classList.add('menu-opened');
        mobile_menu.classList.add('menu-opened');
        e.target.classList.add('active');
      }
      
    } );
}

/**
 * Checks if an element is within the viewport, considering an optional offset.
 *
 * @param {Element} element - The DOM element to check.
 * @param {number} offset - The offset to apply to the element's position.
 * @returns {boolean} - Returns true if the element is within the viewport, false otherwise.
 */
export const inViewport = (element, offset) => {
  // Get the current vertical scroll position
  let scroll = window.scrollY;

  // Calculate the top and bottom of the element's scope, including the offset
  let scope_top = element.getBoundingClientRect().top + scroll + offset;
  let scope_bottom = scope_top + element.clientHeight;

  // Define the top and bottom of the viewport
  let viewport_top = scroll;
  let viewport_bottom = window.innerHeight + scroll;

  // Check if the element is within the viewport
  return (
    (scope_bottom >= viewport_top && scope_bottom <= viewport_bottom) ||
    (scope_top <= viewport_bottom && scope_top >= viewport_top)
  );
};

/**
 * Checks if an element's center is within the middle of the viewport.
 * 
 * @param {Element} element - The DOM element to check.
 * @return {boolean} - True if the element's center is in the middle of the viewport, otherwise false.
 */
const isInMiddleOfScreen = (element) => {
  const rect = element.getBoundingClientRect();
  const elementCenter = rect.top + rect.height / 2;
  const viewportCenter = (window.innerHeight || document.documentElement.clientHeight) / 2;

  // Check if the element's center is within the height of the element around the viewport center
  return (
    elementCenter >= viewportCenter - rect.height / 2 &&
    elementCenter <= viewportCenter + rect.height / 2
  );
};

/**
 * Initializes the accordion.
 */
export const initAccordion = () => {
  // Select all elements with class 'js-accordion-click'
  const accordionButton = document.querySelectorAll('.js-accordion-button');
  accordionButton &&
      accordionButton.forEach((item) => {
          item.addEventListener('click', () => {
              const accordionParent = item.closest('.js-accordion-parent');
              const accordionItem = item.closest('.js-accordion-item');
              
              if (accordionItem?.classList.contains('active')) {
                accordionItem?.classList.remove('active');
              } else {
                const headerHeight = document.querySelector('.site-header').offsetHeight;
                const activeAccordion = accordionParent?.querySelector( '.js-accordion-item.active' );
                activeAccordion?.classList.remove('active');
                accordionItem?.classList.add('active');
                
                setTimeout(() => {
                  const targetPosition = accordionItem.offsetTop - headerHeight;
                  // Smooth scroll to the target position
                  window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                  });
                }, 310);

                const slider = accordionParent.querySelector('.js-goals-slider').swiper;
                if(slider) {
                  slider.slideToLoop(0);

                  if (slider.autoplay) {
                    slider.autoplay.start();
                  }
                }
              }
          });
      });
};

/**
 * Adds click event listeners to elements with the 'scroll-to' class.
 * On click, reads the 'rel' attribute value and scrolls to the section
 * with the corresponding 'id', adjusting for the height of a fixed header.
 */
export const setupScrollTo = () => {
  // Select all elements with the 'scroll-to' class
  const links = document.querySelectorAll('.scroll-to > a');
  // Get the height of the fixed header
  const headerHeight = document.querySelector('.site-header').offsetHeight;

  //Get mobile menu button
  const mobileBtn = document.querySelector('.js-mobile-menu-toggle');

  // Check if links exist and attach click event listeners
  if (links) {
    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent the default link behavior

        //Close mobile menu if it's opened
        if (mobileBtn.classList.contains('active')) {
          mobileBtn.click();
        }

        // Get the value of the 'rel' attribute
        const targetId = link.getAttribute('rel');
        // Select the target section by the 'id' matching the 'rel' attribute
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          // Calculate the position to scroll to, accounting for the header height
          const targetPosition = targetElement.offsetTop - headerHeight;
          
          // Smooth scroll to the target position
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        } else {
          // Redirect to the homepage with a query parameter for the target section
          window.location.href = `/?section=${targetId}`;
        }
      });
    });
  }
};

/**
 * Checks if there's a query parameter for section scroll and scrolls to that section
 * after the page loads.
 */
export const handleSectionScrollFromQuery = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const targetId = urlParams.get('section');
  const targetBlock = urlParams.get('block');

  if (targetId) {
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      const headerHeight = document.querySelector('header').offsetHeight;
      
      setTimeout(() => { 
        const targetPosition = targetElement.offsetTop - headerHeight;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }, 200);
    }
  }

  if (targetBlock) {
    const targetElement = document.getElementById(targetBlock);
    if (targetElement) {
        // Get the element's top position relative to the document
        const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;

        // Get the viewport height
        const viewportHeight = window.innerHeight;

        // Calculate the target position
        const targetPosition = elementTop - (viewportHeight / 2) + (targetElement.offsetHeight / 2);

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }

};

/**
 * Initializes Userway.
 */
let userwayInitialized = false;
export const initializeUserway = () => {
  if (userwayInitialized) {
      return;
  }
  const s = document.createElement('script');
  s.setAttribute('data-language', 'en');
  s.setAttribute('data-account', 'LCo6MCQIvl');
  s.defer = true;
  s.setAttribute('src', 'https://cdn.userway.org/widget.js');
  (document.body || document.head).appendChild(s);
  userwayInitialized = true;
};

/**
 * Adds a click event listener to the button with the class `js-scroll-top`.
 * When clicked, the page smoothly scrolls to the top.
 */
export const addScrollToTopEvent = () => {
  const scrollTopButton = document.querySelector('.js-scroll-top');
  
  if (!scrollTopButton) return; // Return if the button doesn't exist

  scrollTopButton.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent any default action (e.g., link navigation)

      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      });
  });
};

export const initTextFillAnimation = () => {
  let paragraph = document.querySelectorAll('.js-accordion-fill-text');

  if(!paragraph) {
    return;
  }

  paragraph = new SplitType (paragraph, {types: 'lines'});

  gsap.config({ trialWarn: false });
  gsap.registerPlugin(ScrollTrigger);

  paragraph.lines.forEach((target) => {
    gsap.to(target, {
      backgroundPositionX: 0,
      ease: "none",
      scrollTrigger: {
        trigger: target,
        markers: false,
        scrub: 1,
        start: "top center",
        end: "bottom center"
      }
    });
  });
}
